import { Modal, Table, Typography, Popconfirm, Button } from "antd";
import { useState } from "react";
import { doc, getFirestore, updateDoc } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { EditOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons";

import { AddItem } from "./AddItem";
import { EditItems } from "./EditItems";
import { checkAccess } from "../../access";
import { logUserAction } from "../../logs";
import { APP_VERSION } from "../../utils";

export const ItemsView = ({ isModalOpen, setIsModalOpen, detail, order, brands, categories, updateItems, updateOrder, role, setOrder,products }) => {

    const querydb = getFirestore();
    const auth = getAuth();

    const [isItemsOpen, setItemsOpen] = useState(false);
    const [item, setItem] = useState();
    const [isAddOpen, setIsAddOpen] = useState(false);

    const selectItem = (record) => {
        setItem();
        setItem(record);
        setTimeout(() => {
            setItemsOpen(true);
        }, 2000);
    }

    console.log(order);

    const handleDelete = async (product, order) => {

        try {
            const newDetail = detail.filter(item => item.sku !== product.sku);
            await updateDoc(doc(querydb, "orders", order.key), {
                products: newDetail,
                saleAmount: Number(order.saleAmount) - Number(product.total),
                payable: ((Number(order.saleAmount) - Number(product.total)) + Number(order.shippingAmount)) - Number(order.advanceDelivery),
            });
            logUserAction(querydb, auth, "DELETE_ITEM", order.serial, product.sku, product, APP_VERSION);
            await updateItems(order);
            await updateOrder();
            setIsModalOpen(false);
        } catch (error) {
            console.log(error);
        }
    }

    const columns = [
        {
            title: "Marca",
            dataIndex: "brand",
            key: "brand",
            editable: true,
        },
        {
            title: "Categoria",
            dataIndex: "category",
            key: "category",
            editable: true,
        },
        {
            title: "Color",
            dataIndex: "color",
            key: "color",
            editable: true,
        },
        {
            title: "Modelo",
            dataIndex: "model",
            key: "model",
            editable: true,
        },
        {
            title: "SKU",
            dataIndex: "sku",
            key: "sku",
            editable: true,
        },
        {
            title: "Talla",
            dataIndex: "size",
            key: "size",
            editable: true,
        },
        {
            title: "Cantidad",
            dataIndex: "quantity",
            key: "quantity",
            editable: true,
        },
        {
            title: "Precio unitario",
            dataIndex: "unt",
            key: "unt",
            render: (_, record) => {
                const untPrice = (Number(record.total) / Number(record.quantity)).toFixed(2);
                return (
                    <span>${untPrice}</span>
                );
            }
        },
        {
            title: "Precio total",
            dataIndex: "total",
            key: "total",
            editable: true,
            render: (_, record) => {
                return (
                    <span>${record.total.toFixed(2)}</span>
                );
            }
        },
        {
            title: "Observaciones",
            dataIndex: "observation",
            key: "observation",
            editable: true,
            render: (_, record) => {
                return (
                    <span>{record.observation || "SIN OBSERVACIONES"}</span>
                );
            }
        },
        {
            title: "Accion",
            dataIndex: "operation",
            key: "operation",
            fixed: "right",
            render: (_, record) => {
                return !checkAccess("editOrders", role) ? null : (
                    <div style={{ textAlign: "center" }}>
                        <Typography.Link
                            onClick={() => selectItem(record)}
                            className="text-link"
                        >
                            <EditOutlined />
                        </Typography.Link>
                        <Popconfirm
                            title="¿Desea eliminar este item?"
                            onConfirm={() => handleDelete(record, order)}
                            okText="Si"
                            cancelText="No"
                            placement="topRight"
                        >
                            <Typography.Link style={{ marginLeft: "10px" }} className="text-link">
                                <DeleteOutlined />
                            </Typography.Link>
                        </Popconfirm>
                    </div>
                );
            },
        },
    ];

    if(order && order.products){
        console.log(order.products);
    }

    return (
        <Modal
            open={isModalOpen}
            onOk={() => {
                setOrder(null);
                setIsModalOpen(false);
            }}
            onCancel={() => {
                setOrder(null);
                setIsModalOpen(false);
            }}
            cancelButtonProps={{
                style: {
                    display: "none",
                },
            }}
            title={order ? `Detalle pedido ${order.serial} ${order.customerName}` : null}
        >
            {!order ? null
                : <>
                    <br />
                    {!checkAccess("editOrders", role) ? null : <Button type="primary" style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }} onClick={() => setIsAddOpen(true)} icon={<PlusOutlined />} />}
                    <br />
                    <br />
                    <AddItem
                        isOpen={isAddOpen}
                        setIsOpen={setIsAddOpen}
                        brands={brands}
                        categories={categories}
                        order={order}
                        updateItems={updateItems}
                        updateOrder={updateOrder}
                        itemsViewable={setIsModalOpen}
                    />
                    {order && order.products.length ? <div>
                        <Table
                            dataSource={products}
                            columns={columns}
                            scroll={{ x: 1200 }}
                            pagination={10} />

                    </div> : null}
                    <EditItems
                        isItemsOpen={isItemsOpen}
                        setItemsOpen={setItemsOpen}
                        brands={brands}
                        categories={categories}
                        record={item}
                        setRecord={setItem}
                        order={order}
                        updateOrder={updateOrder}
                        itemsView={setIsModalOpen}
                    />
                </>}

        </Modal>
    );
}